export default __webpack_public_path__ + "static/media/Size2D.70bcf6b7.png";